import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../components/Button';
import Processing from '../../components/Processing';

import './EditAddress.less';

const validateAddressFields = (fields) => {
  let nonBlankFields = [
    'name',
    'address1',
    'city',
    'state',
    'postal_code'
  ];

  return nonBlankFields.reduce((response, fieldKey) => {
    if (fields[fieldKey].trim().length === 0) {
      response[fieldKey] = 'Field cannot be blank';
    }

    return response;
  }, {});
};

export default class EditAddress extends React.Component {
  static propTypes = {
    save: PropTypes.func.isRequired,
    cancel: PropTypes.func,
    address: PropTypes.object,
    error: PropTypes.object,
    buttonText: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.save = this.save.bind(this);
    this.onChange = this.onChange.bind(this);

    let address = props.address || {};

    this.state = {
      'name': address.name || '',
      'address1': address.address1 || '',
      'address2': address.address2 || '',
      'city': address.city || '',
      'state': address.state || '',
      'postal_code': address.postal_code || '',
      'instructions': address.instructions || '',
      fieldsWithError: {}
    };
  }

  save() {
    let fieldsWithError = validateAddressFields(this.state);

    this.setState({ fieldsWithError });
    if (Object.keys(fieldsWithError).length > 0) {
      return Promise.reject(fieldsWithError);
    }
    return this.props.save(this.state);
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render() {
    let cancelDiv = this.props.cancel ? <div className="col-50"><Button color="white" onClick={this.props.cancel}>Cancel</Button></div> : null;

    let fieldsWithError = {};
    let errorMessage = null;
    if (this.props.error) {
      if (this.props.error.response && this.props.error.response.field) {
        fieldsWithError[this.props.error.response.field] = this.props.error.response.message;
      } else {
        errorMessage = <div className="error-message">{this.props.error.message || 'There was an error adding this address'}</div>;
      }
    }

    let buttonRow = null;
    let saveButton = <Button className="full-width" onClick={this.save} waitingState={<Processing/>}>{this.props.buttonText || 'Save'}</Button>;
    if (cancelDiv) {
      buttonRow =
        <div className="row button-row">
          <div className="col-50">
            {saveButton}
          </div>
          {cancelDiv}
        </div>;
    } else {
      buttonRow =
        <div className="row button-row">
          {saveButton}
        </div>;
    }

    fieldsWithError = Object.assign(fieldsWithError, this.state.fieldsWithError);

    return (
      <div className="edit-address">
        <h2>Where should we send it?</h2>
        <EditAddressForm address={this.state} onChange={this.onChange} fieldsWithError={fieldsWithError} />
        {errorMessage}
        {buttonRow}
      </div>
    );
  }
}

const InputHelper = ({label, errorMessage, name, onChange, value, className}) =>
  <div className={`input input-${name}${errorMessage ? ' input-error' : ''} ${className}`}>
    <label htmlFor="name">{label}<span className="inline-error-message">{errorMessage}</span></label>
    <input className="input" type="text" name={name} onChange={onChange} value={value} />
  </div>;

const EditAddressForm = ({address, onChange, fieldsWithError = {}}) =>
  <div className="edit-address-form">
    <div className="row2">
      <InputHelper name="name" label="Recipient" errorMessage={fieldsWithError.name} onChange={onChange} value={address.name} />
    </div>
    <div className="row2">
      <InputHelper name="address1" label="Address Line 1" errorMessage={fieldsWithError.address1} onChange={onChange} value={address.address1} />
    </div>
    <div className="row2">
      <InputHelper name="address2" label="Address Line 2" errorMessage={fieldsWithError.address2} onChange={onChange} value={address.address2} />
    </div>
    <div className="row2">
      <InputHelper name="city" label="City" errorMessage={fieldsWithError.city} onChange={onChange} value={address.city} className="col-34" />
      <InputHelper name="state" label="State" errorMessage={fieldsWithError.state} onChange={onChange} value={address.state} className="col-33" />
      <InputHelper name="postal_code" label="Postal Code" errorMessage={fieldsWithError.postal_code} onChange={onChange} value={address.postal_code} className="col-33" />
    </div>
    <div className="row2">
      <InputHelper name="instructions" label="Instructions" errorMessage={fieldsWithError.instructions} onChange={onChange} value={address.instructions} />
    </div>
  </div>;

export { EditAddressForm, validateAddressFields };



/** WEBPACK FOOTER **
 ** ./src/views/checkout/EditAddress.js
 **/